import React from "react";
import { Header } from "../components/common/Header";
import Footer from "../components/common/Footer";

export const OrderConfirmation = () => {
  return (
    <div>
      <Header active={0} />
      <main className="h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">Tack för din beställning!</h1>
          <p className="text-lg">
            Din order har mottagits och ett bekräftelsemail har skickats till din e-post.
          </p>
          <p className="text-lg mt-4">
            Vänligen kontrollera din inkorg för mer information.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};
